export default __webpack_public_path__ + "static/media/CN_Fond_Screen.b67c9b08.jpg";